// @mui
import PropTypes from 'prop-types';
import { alpha, styled } from '@mui/material/styles';
import { Card, Typography } from '@mui/material';
// utils
import { fShortenNumber } from '../../../utils/formatNumber';
// components
import Iconify from '../../../components/iconify';

// ----------------------------------------------------------------------

const StyledIcon = styled('div')(({ theme }) => ({
  margin: 'auto',
  display: 'flex',
  borderRadius: '50%',
  alignItems: 'center',
  width: theme.spacing(8),
  height: theme.spacing(8),
  justifyContent: 'center',
  marginBottom: theme.spacing(3),
}));

const StyledFooter = styled('div')(({ theme }) => ({
  position: 'absolute',
  bottom: 0,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  height: 25,
  fontSize: 14,
  width: '100%',
}));

// ----------------------------------------------------------------------

AppExtraSummary.propTypes = {
  color: PropTypes.string,
  icon: PropTypes.string,
  // This card is used as a container with children, so a title and total are
  // not always supplied. Marking them required produced a warning on every
  // dashboard render.
  title: PropTypes.string,
  total: PropTypes.number,
  children: PropTypes.node,
  sx: PropTypes.object,
};

export default function AppExtraSummary({ title, total, icon, color = 'primary', sx, children, ...other }) {
  return (
    <Card
      sx={{
        py: 4,
        px:4,
        boxShadow: 0,
        textAlign:other?.textAlign || 'center',
        color: (theme) => theme.palette[color].darker,
        bgcolor: (theme) => theme.palette[color].lighter,
        ...sx,
        borderRadius: 0,
      }}
      {...other}
    >
      {/* <Typography variant="h3">{fShortenNumber(total)}</Typography> */}

      {!children && (
        <Typography variant="subtitle2" sx={{ opacity: 0.72 }}>
          {title}
        </Typography>
      )}

      {children}
    </Card>
  );
}
